var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.depositComponent,_vm._b({tag:"component"},'component',{nextStep: _vm.nextStep, showErrorPage: _vm.showErrorPage },false))
}
var staticRenderFns = []

export { render, staticRenderFns }